// External libraries
import { faClose } from "@fortawesome/sharp-regular-svg-icons";

// Internal
import { FontAwesome } from "../icons/icons";

export function CloseButton(props) {
    if (!props.Visible) {
        return null;
    }

    return (
        <button type="button" className="eone-ui-button-tertiary eone-ui-modal-close-button" onClick={props.Close} data-testid={props.DataTestId} aria-label="Close">
            <FontAwesome Title={"Close"} Visible={props.Visible} Icon={faClose} ClassName="eone-ui-modal-close-button-icon" />
        </button>
    );
}